import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Price = ({
    className,
    amount
}) => {
    const classes = classNames(
        'Price',
        className
    );
    const priceArr = (amount / 100)
        .toFixed(2)
        .toString('0.00')
        .replace(/\.0+$/, '')
        .split('.');
    const dollars = `$${priceArr[0]}`;
    const cents = (priceArr[1])
        ? <sup>{priceArr[1]}</sup>
        : null;

    return (
        <span className={classes}>
            {dollars}{cents}
            <meta
                itemProp="price"
                content={`${priceArr[0]}.${(priceArr[1]) ? priceArr[1] : '00'}`}
            />
            <meta
                itemProp="priceCurrency"
                content="USD"
            />
        </span>
    );
};

Price.propTypes = {
    className: PropTypes.string,
    amount: PropTypes.number.isRequired
};

export default Price;
